<div class="newpost-footer profile-image-container" [formGroup]="form">
  <div class="form-group">
    <label class="parent-label" *ngIf="field.label">
      {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    </label>
    <div class="preference-profile">
      <div class="preference-profile-inner" [ngClass]="{'has-image': !!(imageFeedPreview || form?.get(field?.name)?.value)}">
        <div *ngIf="showProgress && cs.isBrowser" class="show-progress-bar pointer-none">
          <circle-progress
            [percent]="percent"
            [radius]="23"
            [outerStrokeWidth]="3"
            [innerStrokeWidth]="3"
            [outerStrokeColor]="cs.isWhiteLabelWeb ? cs.whiteLabelData?.data?.whiteLabel?.theme_color : '#09c6da'"
            [innerStrokeColor]="'#47665f'"
            [animation]="false"
            [animationDuration]="300"
            [showSubtitle]="false"
            [backgroundPadding]="0"
            [titleFontSize]="10"
            [titleColor]="'#ffffff'"
            [unitsColor]="'#ffffff'"
            [space]="-3"
          ></circle-progress>
        </div>
        <em *ngIf="field.groupIconImage" class="icon-liteic-people"></em>
        <img
          [src]="imageFeedPreview || form.get(field.name).value"
          alt="logo"
        />
        <div class="preference-profile-upload" (click)="item.click()">
          <label class="mb-0" (click)="$event.stopPropagation()">
            <input
              #item
              (change)="fileChangeEvent($event)"
              type="file"
              [accept]="application.IMAGE_ACCEPT_TYPES"
              appMobileBridgeFileInput
              (mobileFileChange)="mobileFileChangeEvent($event)"
              [fileConfig]="{
                isMultiple: false,
                cropperOptions: {
                  cropperMinWidth: 250,
                  cropperMinHeight: 250,
                  cropperStaticWidth: null,
                  cropperStaticHeight: null,
                  aspectRatio: 1,
                  maintainAspectRatio: true
                },
                roundCropper: true
              }"
            />
            <span>
              <em class="icon-forum-cam"></em>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <app-image-cropper
    *ngIf="isOpen"
    [imageChangeEvent]="imageChangedEvent"
    [isOpen]="isOpen"
    [cropperOptions]="{
      cropperMinWidth: 250,
      cropperMinHeight: 250,
      cropperStaticWidth: null,
      cropperStaticHeight: null,
      aspectRatio: 1,
      maintainAspectRatio: true
    }"
    [roundCropper]="true"
    [imageWidth]="imageWidth"
    (closeCrop)="cancelCrop($event)"
    (cropImageUpload)="imageFeedClicked($event)"
  ></app-image-cropper>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
